import request from 'api/requestUtils'

import type { WrappedData, WrappedTotalsData } from 'components/Pages/Wrapped/types/wrapped'
import mapWrappedResponse, { mapWrappedTotalsResponse } from './mapWrappedResponse'
import type { ServerWrappedResponse, ServerWrappedTotalsResponse } from './types'

export async function getMyWrapped(): Promise<WrappedData> {
  const response = await request.get<ServerWrappedResponse>(
    '/api/carts/wrapped/me',
    { credentials: 'include' },
  )
  return mapWrappedResponse(response)
}

export async function getWrappedTotals(regionCode: string): Promise<WrappedTotalsData> {
  const response = await request.get<ServerWrappedTotalsResponse>(
    `/api/carts/wrapped/totals?region=${encodeURIComponent(regionCode)}`,
    { credentials: 'include' },
  )
  return mapWrappedTotalsResponse(response)
}

export async function getSharedWrapped(uuid: string): Promise<WrappedData> {
  const response = await request.get<ServerWrappedResponse>(
    `/api/carts/wrapped/${uuid}`,
  )
  return mapWrappedResponse(response)
}
